<template>
  <embedded-crud-table
    :entity="entity"
    :entity-store="entityStore"
    :columns="columns"
    :definition="{}"
    :generate-summary="() => {}"
    :caption="caption"
    :disabled="true"
    :allow-actions="false"
    :allow-delete="false"
    parent-id-filter-field="productID"
    :open-in-fullscreen="openInFullscreen"
    :required="required"
    :create-item-from-form-data="() => {}"
    :create-form-data-from-item="() => {}"
    permission-code="StockCorrection"
    :on-table-row-double-click="onTableRowDoubleClick"
  />
</template>

<script>
import EmbeddedCrudTable from '@/components/crud/EmbeddedCrudTable';
import { entityToStore } from '@/utils/store';
import { ReasonStockCorrectionOption } from '@/utils/constants';

export default {
  components: {
    EmbeddedCrudTable
  },
  props: {
    caption: String,
    disabled: {
      default: false,
      type: Boolean
    },
    openInFullscreen: {
      default: false,
      type: Boolean
    },
    required: {
      default: false,
      type: Boolean
    }
  },
  data: () => ({
    entity: 'StockCorrection'
  }),
  computed: {
    entityStore() {
      return entityToStore(this.entity);
    },
    columns() {
      return [
        { field: 'creationWeek', label: 'common.week', filter: { type: 'none' }, sortable: false, width: 150 },
        { field: 'createdAt', label: 'stockCorrection.createdAt', width: 150, type: 'date', filter: { type: 'date' } },
        { field: 'correction', label: 'stockCorrection.mutation', width: 150, filter: { type: 'none' } },
        {
          field: 'stockLocationName',
          label: 'stock.stockLocationName',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'reasonStockCorrectionDescription',
          label: 'stockCorrection.reason'
        },
        {
          field: 'fabricOrderNumber',
          label: 'fabricOrder.orderNumber',
          filter: { type: 'none' },
          sortable: false
        },
        {
          field: 'remarks',
          label: 'common.remarks',
          filter: { type: 'none' },
          sortable: false
        }
      ];
    }
  },
  methods: {
    onTableRowDoubleClick(row) {
      if (!(row && row.fabricOrderNumber)) {
        return;
      }
      if (row.reasonStockCorrectionOption === ReasonStockCorrectionOption.OrderPick) {
        const id = +row.fabricOrderNumber;
        this.$router.push({ name: 'CompleteOrderPickList', params: { id } });
      } else if (row.reasonStockCorrectionOption === ReasonStockCorrectionOption.FabricOrderDelivery) {
        this.$router.push({
          name: 'FabricOrder',
          params: {
            filters: {
              orderNumber: row.fabricOrderNumber
            }
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
